var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-guild-search-field"
  }, [_c('div', {
    staticClass: "cm-guild-search-field__input-wrapper"
  }, [_c('label', {
    staticClass: "cm-guild-search-field__placeholder",
    class: {
      "cm-guild-search-field__placeholder--visible": _vm.value === "",
    },
    attrs: {
      "for": "cm-guild-search-field__input"
    }
  }, [_vm._v("\n      Search "), _c(_vm.resultCount ? "strong" : "span", {
    tag: "component"
  }, [_vm._v(_vm._s(_vm.placeholderLabel))]), _vm._v(" by keyword\n    ")], 1), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "cm-guild-search-field__input",
    attrs: {
      "id": "cm-guild-search-field__input",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit("input", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cm-guild-search-field__icon"
  }, [_vm._v("🔎")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86d1cd4c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/guild-search.vue
// module id = null
// module chunks = 